import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryAllowedEnvironments({ count, ...params }) {
  const url = count ? '/environment/allowed/count' : '/environment/allowed';
  return request(url, { params: toQuery(params) });
}

export async function queryAllowedSites(params) {
  return request('/processPortal/allowed', {
    params: toQuery({
      ...params,
      select: 'id,name,shortCode,description,logoUrl,faviconUrl',
      limit: 100,
    }),
  });
}

export async function queryChangeEnvironment({ id }) {
  return request.post(`/account/changeEnvironment/${id}`);
}

// New accessible-company contract (replaces the legacy OData `/company/allowed`).
// See the "Selector de empresa accesible" UX/API reference: this endpoint returns
// a flat `UserAccessibleCompanyInfo[]` (one object per company) and only accepts
// `search` (substring) and `companyId` (single-company validation) query params.
export async function queryCompanies({ count, search, companyId } = {}) {
  if (count) return request('/company/accessible/count');

  const params = {
    ...(search && { search }),
    ...(companyId && { companyId }),
  };

  return request('/company/accessible', {
    ...(!_.isEmpty(params) && { params }),
  });
}

export async function queryChangeCompany({ id, accessId, environmentId }) {
  return request.post(`/account/changeCompany/${id}/${accessId}`, {
    ...(environmentId && { params: { environmentId } }),
  });
}
